<template lang="pug">
  div.container-fluid
    div.row(v-show="fail")
      div.col(style="text-align: center;")
        p(style="cursor:pointer;", @click="_showDetail")
          | 読み込みに失敗しました
          br
          | クリックして再読み込み
    div.row(v-show="!fail")
      div.col
        h4.d-inline-block(v-if="result.status==200") {{ result.school }}
        h4.d-inline-block.float-right(v-if="result.status==200") {{ result.year }}
        content-loader(v-show="result.status==0",
              :height="16",
              :width="300",
              :speed="2",
              primaryColor="#f3f3f3",
              secondaryColor="#ecebeb")
          rect(x="25", y="4", rx="2", ry="2", width="200", height="8")
          rect(x="250", y="4", rx="2", ry="2", width="50", height="8") 
    div.row
      div.col(style="padding:0px;")
          div.box26(style="font-size: 12px;")
            span.box-title Writer Profile
            div.table-responsive
              table.table.table-sm(style="text-align:center;")
                thead
                  tr
                    th 勤続年数
                    th 受験年齢
                    th 私費・社費
                    th キャリア
                    th 希望進路
                    th 志望キャリア
                tbody
                  tr(v-show="result.status==0")
                    td(colspan="6", style="vertical-align:middle;")
                      content-loader(
                          :height="18",
                          :width="295",
                          :speed="2",
                          primaryColor="#f3f3f3",
                          secondaryColor="#ecebeb")
                        rect(x="10", y="6", rx="2", ry="2", width="20", height="6")
                        rect(x="55", y="6", rx="2", ry="2", width="20", height="6")
                        rect(x="105", y="6", rx="2", ry="2", width="20", height="6")
                        rect(x="140", y="6", rx="2", ry="2", width="50", height="6")
                        rect(x="200", y="6", rx="2", ry="2", width="20", height="6")
                        rect(x="240", y="6", rx="2", ry="2", width="50", height="6")
                  tr(v-show="result.status==200")
                    td {{ result.length }}
                    td {{ result.age }}
                    td {{ result.expense? "私費":"社費" }}
                    td {{ $store.state.careerl[result.career1] }}
                      br
                      | {{ $store.state.careers[result.career1] }}
                    td {{ $store.state.postmba[result.postmba] }}
                    td {{ $store.state.careerl[result.career2] }}
                      br
                      | {{ $store.state.careers[result.career2] }}
            p(v-show="result.status==200 & result.profile.length!=0") {{ result.profile }}
    div.row
      div.col(style="padding:0px;")
        div.box26(style="padding:16px;")
          span.box-title Essay List
          div.table-responsive
            table.table.table-hover.table-sm(style="font-size:12px;")
              tbody
                tr(v-show="result.status==0", v-for="i in [1,2,3,4]", :key="i")
                  td(colspan="6")
                    content-loader(
                        :height="18",
                        :width="295",
                        :speed="2",
                        primaryColor="#f3f3f3",
                        secondaryColor="#ecebeb")
                      rect(x="0", y="6", rx="3", ry="3", width="15", height="6")
                      rect(x="20", y="6", rx="3", ry="3", width="15", height="6")
                      rect(x="40", y="6", rx="3", ry="3", width="110", height="6")
                      rect(x="155", y="6", rx="3", ry="3", width="35", height="6")
                      rect(x="195", y="6", rx="3", ry="3", width="35", height="6")
                      rect(x="235", y="6", rx="3", ry="3", width="60", height="6")

                tr.table-primary(v-show="result.status==200")
                  td(v-show="!this.$store.state.auth.loggedin || this.$store.state.auth.role==='user'", style="height:50px;width:50px;")
                    button.btn.btn-light.d-inline-flex.justify-content-center(type="button", style="padding:6px;width:40px;", @click="wishItem(result.set_item_id)")
                      font-awesome-icon(icon="star", v-show="$store.state.listitems.wish.indexOf(result.set_item_id)>-1", style="font-size:1.5rem;")
                      font-awesome-icon(:icon="['far','star']", v-show="$store.state.listitems.wish.indexOf(result.set_item_id)==-1", style="font-size:1.5rem;")
                  td(style="padding-left:10px;") SET<br>Q1～Q{{ result.num_of_essays }}
                  td(style="text-align:center;") Words <br> Chars
                  td(style="text-align:center;") ￥{{ Number(result.set_price).toLocaleString() }}
                  td(v-show="!$store.state.auth.loggedin || $store.state.auth.role==='user'")
                    button.btn.btn-primary(v-show="$store.state.listitems.own.indexOf(result.set_item_id)<0 && $store.state.listitems.cart.indexOf(result.set_item_id)<0", type="button", style="width:65px;", @click="addCart(result.set_item_id, result.essays)") <font-awesome-icon icon="shopping-cart"></font-awesome-icon>&nbsp;<font-awesome-icon icon="plus"></font-awesome-icon>
                    button.btn.btn-secondary(v-show="$store.state.listitems.own.indexOf(result.set_item_id)<0 && $store.state.listitems.cart.indexOf(result.set_item_id)>-1", type="button", style="width:65px;", @click="removeCart(result.set_item_id)") <font-awesome-icon icon="shopping-cart"></font-awesome-icon>&nbsp;<font-awesome-icon icon="minus"></font-awesome-icon>
                    button.btn.btn-info(v-show="$store.state.listitems.own.indexOf(result.set_item_id)>-1", type="button", style="width:65px;", disabled="disabled") 購入済
                tr(v-show="result.status==200", v-for="essay in result.essays", :key="essay.essay_id",:class="result.highlight_essay_id==essay.essay_id? 'highlight':''")
                  td(v-show="!$store.state.auth.loggedin || $store.state.auth.role==='user'", style="height:50px;width:50px;")
                    button.btn.btn-light.d-inline-flex.justify-content-center(type="button", style="padding:6px;width:40px;", @click="wishItem(essay.item_id)")
                        font-awesome-icon(icon="star", v-show="$store.state.listitems.wish.indexOf(essay.item_id)>-1", style="font-size:1.5rem;")
                        font-awesome-icon(:icon="['far','star']", v-show="$store.state.listitems.wish.indexOf(essay.item_id)==-1", style="font-size:1.5rem;")
                  td(v-popover.top="{ name:essay.essay_id }", style="padding-left:10px; cursor: pointer;", :title="essay.question") Q{{ essay.question_no }} <br> <font-awesome-icon icon="info-circle"></font-awesome-icon>
                  td(style="text-align:center;")
                    | {{ essay.word_count }}
                    br
                    | {{ essay.char_count }}
                  td(style="text-align:center;") ￥{{ Number(essay.price).toLocaleString() }}
                  td(v-show="!$store.state.auth.loggedin || $store.state.auth.role==='user'")
                    button.btn.btn-info(v-show="$store.state.listitems.own.indexOf(result.set_item_id)<0 && $store.state.listitems.cart.indexOf(result.set_item_id)>-1", type="button", style="width:65px;", disabled="disabled") <font-awesome-icon icon="shopping-cart"></font-awesome-icon>&nbsp;SET&nbsp;<font-awesome-icon icon="check"></font-awesome-icon>
                    button.btn.btn-primary(v-show="$store.state.listitems.own.indexOf(result.set_item_id)<0 && $store.state.listitems.cart.indexOf(result.set_item_id)<0 && $store.state.listitems.own.indexOf(essay.item_id)<0 && $store.state.listitems.cart.indexOf(essay.item_id)<0 ", type="button", style="width:65px;", @click="addCart(essay.item_id, [])") <font-awesome-icon icon="shopping-cart"></font-awesome-icon>&nbsp;<font-awesome-icon icon="plus"></font-awesome-icon>
                    button.btn.btn-secondary(v-show="$store.state.listitems.own.indexOf(result.set_item_id)<0 && $store.state.listitems.cart.indexOf(result.set_item_id)<0 && $store.state.listitems.own.indexOf(essay.item_id)<0 && $store.state.listitems.cart.indexOf(essay.item_id)>-1", type="button", style="width:65px;", @click="removeCart(essay.item_id)") <font-awesome-icon icon="shopping-cart"></font-awesome-icon>&nbsp;<font-awesome-icon icon="minus"></font-awesome-icon>
                    button.btn.btn-info(v-show="$store.state.listitems.own.indexOf(result.set_item_id)>-1 || $store.state.listitems.cart.indexOf(result.set_item_id)<0 && $store.state.listitems.own.indexOf(essay.item_id)>-1", type="button", style="width:65px;", disabled="disabled") 購入済
                  popover(:name="essay.essay_id", width="350") {{ essay.question }}
    div.row
      div.col(v-show="result.status==200 && result.others.length>0", style="padding:0px; text-align: left;")
        div.box26(style="padding:16px;")
          span.box-title このWriterの他のエッセイ
          p(v-for="link in result.others", :key="link.sid", @click="ShowDetail(link.wid, link.sid)", style="color:blue; cursor:pointer;") {{ link.text }}

    div.modal.fade#registermodal(role="dialog", tabindex="-1")
      div.modal-dialog.modal-sm.modal-dialog-centered(role="document")
        div.modal-content
          div.modal-body
            div.container-fluid
              div.row
                div.col-12
                  p エッセイがカートに追加されました
                div.col-6
                  button.btn.btn-info(type="button",  data-dismiss="modal", aria-label="Close") 検索に戻る
                div.col-6
                  button.btn.btn-danger(type="button", @click="gocart") レジに進む


</template>

<script>
import { ContentLoader } from "vue-content-loader"

export default {
  name: "DetailMoble",
  components: {
      ContentLoader
  },
  props:[
  ],
  data (){
    return {
      result:{status:0, num_of_essays:0, writer_id:0, school_id:0, school:"", career1:1, expense:true, length:1, age:0, postmba:0, career2:1, year:0, profile:"", set_item_id:0, set_price:0, essays:[], others:[]},
      fail:false,
      writer_id:0,
      school_id:0,
      essay_id:NaN
    }
  },
  mounted (){
    this.writer_id = Number(this.$route.query.wid);
    this.school_id = Number(this.$route.query.sid);
    this.essay_id = Number(this.$route.query.eid);
    this._showDetail();
  },
  methods: {
    ShowDetail (wid, sid, eid){
      this.writer_id = wid;
      this.school_id = sid;
      this.essay_id = eid;
      this._showDetail()
    },
    _showDetail (){
      this.result.status = 0;
      this.fail = false;
      let data = {
        writer_id:this.writer_id,
        school_id:this.school_id
      };
      if(this.essay_id)
        data.essay_id = this.essay_id;
      this.$axios.post("/api/essayset", data)
      .then((response) => {
        this.result = response.data;
      })
      .catch((error) => {
        this.fail = true;
      });
    },
    wishItem: function(item_id){
      let data = {
        item_id:item_id,
      };
      if (this.$store.state.listitems.wish.indexOf(item_id) > -1)
        data.target = "delete";
      else
        data.target = "append";
      this.$store.commit("wishitem", data);

    },
    addCart: function(item_id, removeList){
        this.$store.commit("addCart", item_id);
        if (removeList.length>0)
            this.$store.commit("removeCartMultiple", removeList);
        $("#registermodal").modal("show");
    },
    removeCart: function(item_id){
        this.$store.commit("removeCart", item_id);
    },
    gocart (){
      $("#registermodal").modal("hide");
      this.$router.push("/cart");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.detailModal {
  text-align: left;
}

.row {
  margin-left: 3px;
  margin-right: 3px;
}

td {
  vertical-align:middle;;
}

.box26 {
  position:relative;
  margin:12px 0;
  padding:0.5em 1em;
  border:solid 1px #999;
  /*border-radius:3px;*/
}

.box26 .box-title {
  position:absolute;
  display:inline-block;
  top:-13px;
  left:10px;
  padding:0 9px;
  line-height:1;
  font-size:19px;
  background:#FFF;
  color:#999;
  font-weight:bold;
}

.box26 p {
  margin:0;
  padding:0;
}

.vue-popover {
    background: navajowhite!important;
}

.vue-popover.dropdown-position-top:before {
    border-top: 6px solid navajowhite!important;
}

.vue-popover.dropdown-position-top{
    margin: 10px auto;
    left: -15px!important;
}

button.btn.cartbtn[data-item=0] {
    content: "カートに入れる";
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

button.btn.cartbtn[data-item=0] :after{
    content: "カートに入れる";
}

.modal-dialog {
    max-width: 90%;
    margin: 1.75rem auto;
}

@media (min-width: 992px){
    .modal-lg, .modal-xl {
        max-width: 800px;
    }
}

tr.highlight{
    outline: 3px solid red;
    background-color: #f5c6cb;
    outline-offset: -3px;
}

</style>
